<template>
	<div id="appbox">
		<div class="top_heard">
			<div class="top_box">
				<div class="logo_box"  @click="gohome()">
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
				</div>
				<div class="top_gatebox">
					<div class="manage_switch" v-if="screenWidth>785">
						<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
						  <el-option
						    v-for="item in manageoptions"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value"
							>
						  </el-option>
						</el-select>
					</div>
					
				</div>
				<div class="top_search_box">
			<!-- 		<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
						  <el-option
						    v-for="item in options"
						    :key="item.value"
						    :label="item.label" 
						    :value="item.value">
						  </el-option>
						</el-select>
						<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="getlist()" alt="" srcset="">
					</div> -->
					  
					  
				</div>
				<div class="top_right">
					<div class="top_Mobiletype" @click="goregister()">
						账号注册/绑定
					</div>
					<div class=""  v-if="token" >
						欢迎访问!
					</div>
					<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
						登出
					</div>
				</div>
			</div>
			<div class="top_tab_box">
				<div class="toptabnav">
						<el-menu
						  :default-active="activeIndex2"
						  class="el-menu-demo"
						  mode="horizontal"
						 
						  router
						  background-color="#1b9d57"
						  text-color="#FFFFFF"
						  active-text-color="#FFFFFF">
							<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
				
			</div>
		</div>
		<div class="Home_column2">
			<div class="weus_type">
				<div :class="title=='关于我们'?'weustype_item type_on':'weustype_item'" @click="typetab('关于我们')" >
					关于我们
				</div>
				<div :class="title=='在线留言'?'weustype_item type_on':'weustype_item'" @click="typetab('在线留言')" >
					在线留言
				</div>
				<div :class="title=='隐私权保护'?'weustype_item type_on':'weustype_item'" @click="typetab('隐私权保护')" >
					隐私权保护
				</div>
				<div :class="title=='注册协议'?'weustype_item type_on':'weustype_item'" @click="typetab('注册协议')" >
					注册协议
				</div>
				<div :class="title=='建议反馈'?'weustype_item type_on':'weustype_item'" @click="typetab('建议反馈')" >
					建议反馈
				</div>
				<div :class="title=='入会申请'?'weustype_item type_on':'weustype_item'" @click="typetab('入会申请')" >
					入会申请
				</div>
			</div>
			<div class="weus_main">
				<div class="weus_topimg">
					<img src="../../../static/img/weus1.jpg" alt="" srcset="">
				</div>
				<div class="weus_titles">
					<div class="weus_title">
						{{title}}
					</div>
					<div class="weus_tips">
						{{title}}
					</div>
				</div>
				<div class="weus_html" v-html="richbox" v-if="title!='在线留言'&&title!='建议反馈'" >
					
				</div>
				<div class="upfrom"  v-if="title=='在线留言'||title=='建议反馈'">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm"  size="medium" class="demo-ruleForm">
					  <el-form-item :label="ruleForm.type==1?'留言主题':'反馈主题'"  prop="title" >
					    <el-input  v-model="ruleForm.title"  :placeholder="ruleForm.type==1?'请输入留言主题':'请输入反馈主题'" ></el-input>
				<!-- 		<div class="form_tips">
							手机号码将作为账户登录
						</div> -->
					  </el-form-item>
					  <el-form-item label="联系电话"  prop="contact" >
					  	    <el-input  v-model="ruleForm.contact"  placeholder="请输入联系电话" ></el-input>
					  <!-- 		<div class="form_tips">
					  			手机号码将作为账户登录
					  		</div> -->
					  	  </el-form-item>
					  <el-form-item :label="ruleForm.type==1?'留言详情':'反馈内容'" prop="content" >
						  <el-input
						    type="textarea"
						    :autosize="{ minRows: 6, maxRows:8}"
						    :placeholder="ruleForm.type==1?'请输入留言内容':'请输入反馈内容'"
						   v-model="ruleForm.content">
						  </el-input>
				<!-- 		<div class="form_tips">
							请设置登录密码
						</div> -->
					  </el-form-item>
					  
					  <el-form-item  >
						  <div class="" style="width: 100%;text-align: right;">
							 <el-button type="success" style="background-color:#1b9d57;" v-if="!token" @click="upadvocate('ruleForm')" >提 交</el-button>
							 <el-popover
							   placement="top"
							 	v-model="showreplyvisible"
							    trigger="manual">
							   <div class="verify-box">
							   	<slide-verify
							   	  ref="replyRef"
							   	  :l="42"
							   	  :r="10"
							   	  :w="280"
							   	  :h="280"
							   	  :imgs="images"
							   	  slider-text="向右滑动"
							   	  @success="onreplySuccess"
							   	  @fail="onreplyFail"
							   	  @refresh="onreplyRefresh"
							   	  @fulfilled="onRefreshComplete"
							   	  @again="onreplyAgain"
							   	>
							   	</slide-verify>
							   </div>
							   <el-button type="success" style="background-color:#1b9d57;"  slot="reference" v-if="token" @click="showreplyvisible = true">提 交</el-button>
							 </el-popover>
						  </div>
					   
					  </el-form-item>
					</el-form>
				</div>
				<div  v-if="title=='入会申请'">
						<div class="intro_msg">
						<div class="intro_title">会员招募</div>
						<div class="intro_content">各相关单位、协会各部门、各会员单位：为贯彻落实习总书记关于立德树人的系列重要讲话和全国教育大会精神，践行实践育人教育理念，发挥社会团体行业优势，规范研学旅行服务行为，实现研学旅行资源共享，推动我省研学实践教育事业健康发展，经研究，现面向社会招募会员，具体内容如下：</div>
						<div>
							<div class="intro_subtitle">01招募对象</div>
							<div class="intro_content">河南省内的中小学校、校外活动中心、景区景点及各类场馆、实践教育基地、研学旅行服务机构（包含旅行社和教育公司）以及从业人员。</div>
						</div>
						<div>
							<div class="intro_subtitle">02入会条件</div>
							<div class="intro_paragraph">1.坚持正确的政治方向，拥护党的领导，诚实守信，具有较强的社会责任感和教育情怀；</div>
							<div class="intro_paragraph">2.拥护本协会的章程，自愿加协会；</div>
							<div class="intro_paragraph">3.热心协会工作，愿意为研学实践教育事业的发展作贡献，积极参加协会活动，完成协会交办的工作；</div>
							<div class="intro_paragraph">4.单位会员应是依法注册成立的研学旅行企事业单位和社会组织；</div>
							<div class="intro_paragraph">5.按时缴纳会费。</div>
						</div>
						<div>
							<div class="intro_subtitle">03会员权利</div>
							<div class="intro_paragraph">1.会员单位申请并获得协会“会员之家”资格后，可承办协会委托开展的专题讲座、学术交流和研修培训等工作。</div>
							<div class="intro_paragraph">2.会员可参加全国研学旅行协会联席会议成员单位之间的参观学习、业务交流、考察调研等活动，会员所推荐的自有资源将纳入省域研学旅行资源库。</div>
							<div class="intro_paragraph">3.会员享有协会研学旅行示范课程、精品课程评选和年终评先资格。</div>
							<div class="intro_paragraph">4.会员享有协会研学旅行指导师培训的优惠政策，优秀会员纳入河南省研学旅行教育协会人才库进行编号管理。</div>
							<div class="intro_paragraph">5.会员单位和个人会员都可在河南省研学旅行教育协会官方微信公众号上发布研学活动、研学线路的原创性文章、视频以及人才招聘等信息。</div>
							<div class="intro_paragraph">6.加入“河南省研学旅行教育协会”专属微信群，了解最新研学旅行教育教学成果和协会内部信息。</div>
						</div>
						<div>
							<div class="intro_subtitle">04入会流程</div>
							<div class="intro_paragraph">1.向协会会员中心提出申请，填写入会申请书和会员登记表；</div>
							<div class="intro_paragraph">2.经协会秘书处审核，协会会长办公会审议，在一个月内做出是否同意接纳为会员的通知；</div>
							<div class="intro_paragraph">3.接到入会通知书后，次月内缴纳当年会费，并汇入本会指定银行账户；</div>
							<div class="intro_paragraph">4.协会出具会费收据、并发布公示（一个季度做一次集中公示）。</div>
						</div>
						<div>
							<div class="intro_subtitle">05所需材料</div>
							<div class="intro_paragraph">1.单位会员申请时需提交入会申请书、单位会员登记表和所在单位的营业执照、法人身份证等复印件，负责人两张一寸照片和三个会员证明材料；</div>
							<div class="intro_paragraph">2.个人会员申请时需提交入会申请书、个人会员登记表和身份证复印件。</div>
							
						</div>
						<div>
							<div class="intro_subtitle">06会费说明</div>
							<div class="intro_paragraph">1.开户名称：河南省研学旅行教育协会</div>
							<div class="intro_paragraph">2.账  号：41050163285100000272</div>
							<div class="intro_paragraph">4.备  注：姓名/单位名称（2023年度会费）</div>
							<div class="intro_paragraph">4.协会出具会费收据、并发布公示（一个季度做一次集中公示）。</div>
							<div class="intro_paragraph">5.缴费金额：普通会员：500元/年，单位会员：1500（含3名个人会员）/年。</div>
						</div>
						<div class="intro_subtitle">07联系方式</div>
						<div style="padding-left: 35px;">
							<div class="intro_phone">会员中心:16637190688</div>
						<div class="intro_phone">秘 书 处：0371—66305321</div>
						
				
						<div class="intro_phone" style="width: 100%;">秘书处地址:郑州市金水东路与民生路交叉口永和国际广场b区712室</div>
						<div class="intro_phone" style="width: 100%;">协会地址:河南省新乡市建设东路河南师范大学田家炳教育书院901室</div>
						</div>
						<div class="intro_phone" style="text-decoration: underline;color: blue;margin-top: 20px;" @click="downfile('https://admin.henanyanxue.com/upload/editor/%E4%B8%AA%E4%BA%BA%E4%BC%9A%E5%91%98%E7%99%BB%E8%AE%B0%E8%A1%A8.docx')">
							附件：1.个人会员登记表.docx
						</div>
						<div class="intro_phone" style="text-decoration: underline;color: blue;"  @click="downfile('https://admin.henanyanxue.com/upload/editor/%E5%8D%95%E4%BD%8D%E4%BC%9A%E5%91%98%E7%99%BB%E8%AE%B0%E8%A1%A8.docx')">附件：2.单位会员登记表.docx</div>
						<div style="text-align: end;margin-top: 30px;">河南省研学旅行教育协会</div>
						<div style="text-align: end;margin-top: 10px;">2023年8月8日</div>
						<div class="intro_phone" style="display: flex;width: 1200px;">
							原文链接：
							<a  href="https://mp.weixin.qq.com/s/9YWUxnXQh2vGo-E3DKNvZA" style="text-decoration: underline;color: blue;" target="_blank" rel="noopener noreferrer">https://mp.weixin.qq.com/s/9YWUxnXQh2vGo-E3DKNvZA</a>
						</div>
						<div style="text-align: start;margin-bottom: 10px;margin-top: 10px;font-size: 18px;letter-spacing: 1px;">入会报名:</div>
						<img src="../../../static/img/baoming.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<div :class="tops?'navbar':'navbar-top'">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
							
				    <div style="font-size: 14px;">公众号</div></a>
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		       <!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> -->
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		 <el-dialog
		   title="您还未登录,请登录后再操作"
		   :visible.sync="loginshow"
		    :before-close="onAgain"
		   width="30%"
		   center>
		   <el-form ref="form" :model="form" :rules="rules"  label-width="100px">
		 	  <el-form-item label="手机端账号" prop="mobile">
		 	      <el-input v-model="form.mobile"></el-input>
		 	    </el-form-item>
		 		 <el-form-item label="密码" prop="password">
		 		    <el-input type="password" v-model="form.password" ></el-input>
		 		  </el-form-item>
		 	  <div class=""  @click="goregister()" style="color: #409EFF;width: 100%;text-align: right;">
		 	  	注册账号
		 	  </div>
		 	  
		   </el-form>
		   <span slot="footer" class="dialog-footer">
		    <el-button @click="loginshow = false" style="margin-right: 15px;">取 消</el-button>
		    <el-popover
		      placement="top"
		    	v-model="showvisible"
		       trigger="manual">
		      <div class="verify-box">
		      	<slide-verify
		      	  ref="slideRef"
		      	  :l="42"
		      	  :r="10"
		      	  :w="280"
		      	  :h="280"
		      	  :imgs="images"
		      	  slider-text="向右滑动"
		      	  @success="onSuccess"
		      	  @fail="onFail"
		      	  @refresh="onRefresh"
		      	  @fulfilled="onRefreshComplete"
		      	  @again="onAgain"
		      	>
		      	</slide-verify>
		      </div>
		      <el-button type="primary" slot="reference" @click="showvisible = true">登 录</el-button>
			</el-popover>
		   </span>
		 </el-dialog>
		<!-- footer -->
		<div class="pagesbottom_box">
			<div class="subtexts">
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				<!-- 				<div>商务合作</div>
								<div>招商合作</div>
								<div>广告服务</div>
								<div>线下体验店</div>
								<div>客服中心</div>
								<div>在线留言</div>
								<div>合作伙伴</div>
								<div>联系我们</div>
								<div>人员招聘</div>
								<div>网站地图</div>
								<div>热点关注</div>
								<div>网盟合作</div>
								<div>音乐</div> -->
			</div>
			<div class="row">
				<!-- <div class="copy-left">
					<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
					<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
					<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
				</div> -->
				
				<div class="copy-left">
					<div class="bottom_logo">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<!-- <div class="bottom_logo">
						<img src="../../../static/img/logo2.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div> -->
					<!-- <div class="copy-right">
						<img src="../../../static/img/gzhsuncode.jpg" />
					</div>
					<div class="copy-right">
						<img src="../../../static/img/suncode.jpg" />
					</div> -->
				</div>
				<div class="bottom_right">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import {  checktoken, regettoken, getCamplist, getPc, getRegion ,getTraveler, getPlate,phonelogin,getexpert,getsys,upadvocate,getbottomnav} from '@/request/api'
	
	export default {
	  name: "Camplist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  top_search_url:'/weus',
			  manage_url:'',
			  manageoptions:[
			  	{
			  	  value: 'http://qianjin.wanjiaxiao.cn/',
			  	  label: '研学报备'
			  	}, {
			  	  value: 'https://admin.henanyanxue.com/',
			  	  label: '管理入口'
			  	},
			  
			  ],
			  stitle:'',
			  title:'关于我们',
			  options: [{
			  		  value: '/weus',
			  		  label: '专家搜索'
			  		},],
				platelist:[],
				activeIndex2: '/weus',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				expertdata:{},
				banner:[
				],
				ruleForm: {
				  title: '',
				  contact: '',
				  content: '',
				  type:1,
				},
				rules: {
					contact: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' },
					],
					title: [
						{ required: true, message: '请填写主题', trigger: 'blur' },
					],
					content: [
						{ required: true, message: '请填写留言内容', trigger: 'blur' },
					],
				},
				camptypes:[
					{ text: '全部', value: 0 },
					{ text: '基地', value: 2 },
					{ text: '营地', value: 1 },
				],
				camptype:1,
				camplist:[],
				quicklist:[],
				maplist:[],
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				uuid:'',
				newsdata:{},
				pcsetdata:{},
				openmap:{},
				show: false,
				showinfowindow:false,
				regionlist:[],
				region_type:'',
				modules:'',
				showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:0,
				richbox:'',
				//强制登录
				loginshow:false,
				replytext:'',
				form: {
					mobile: '',
					password: '',
					openid:'',
					unionid:'',
					is_pc:1,
				},
				//滑块验证码
				images: [
					require('../../../static/img/滑块1.jpg'),
					require('../../../static/img/滑块2.jpg'),
					require('../../../static/img/滑块3.jpg')
				],
				tipsMsg:'',
				isSuccess: true,
				showvisible:false,
				//反馈滑块
				showreplyvisible:false,
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		  this.getpcset()  
		//    this.gotop()
		    document.documentElement.scrollTop=0
	  },
	  mounted() {
		 const { title } = this.$route.query;
		 this.title=title
		 var token = localStorage.getItem('token')||''
		 this.token=token
		  this.getbottomnav()
		//   this.gotop()
		 // this.getsys()
		 console.log("滚轮位置",this.scrolltop)
		window.addEventListener('scroll', this.scrollToTop)
		
		
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
	  methods: {
		downfile(url){
				  this.$message({
          message: '已下载',
          type: 'success'
        });
			  window.open(url);
		},	
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		//this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		  onreplySuccess(){
		  						  // this.isSuccess = true;
		  						  this.showreplyvisible=false
		  						  this.upadvocate()
		  						  this.$refs.replyRef.reset();
		  },
		  onreplyFail(){
		  						  
		  },
		  onreplyRefresh(){
		  			  
		  },
		  onreplyAgain(){
		  			   this.$refs.replyRef.reset();
		  			   this.showreplyvisible=false
		  			  // this.loginshow=false
		  },
		  // 成功回调
		  			  onSuccess(){
		  				  this.tipsMsg = '恭喜您，验证成功啦！';
		  				  this.isSuccess = true;
		  						  this.showvisible=false
		  						  this.phonelogin()
		  						  this.$refs.slideRef.reset();
		  			  },
		  			  // 失败回调
		  			  onFail(){
		  				  this.tipsMsg = '验证失败，请重试哦！';
		  				  this.isSuccess = false;
		  			  },
		  			  // 点击刷新回调
		  			  onRefresh(){
		  				  this.tipsMsg = ''
		  			  },
		  			  // 刷新成功后回调
		  			  onRefreshComplete(){
		  						  this.tipsMsg = ''
		  						  this.isSuccess = true;
		  			  },
		  			  // 检测到非人为操作
		  			  onAgain() {
		  						  
		  						this.$refs.slideRef.reset();
		  						 this.showvisible=false
		  						this.loginshow=false
		  			  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  typetab(title){
			  
			  this.title=title;
			  if(title=='关于我们'){
				  console.log(title,title=='关于我们')
				this.richbox=this.pcsetdata.aboutus
			  }
			  if(title=='在线留言'){
			  	this.richbox=''
				this.ruleForm={
				  title: '',
				  contact: '',
				  content: '',
				  type:1,
				}
			  }
			  if(title=='建议反馈'){
			  	this.richbox=''
			  	this.ruleForm={
				  title: '',
				  contact: '',
				  content: '',
				  type:2,
				}
			  }
			  if(title=='隐私权保护'){
				this.richbox=this.pcsetdata.privacy	  
			  }
			  if(title=='注册协议'){
				this.richbox=this.pcsetdata.registration_agreement
			  }
		  },
		  gologin(){
		  			  this.$router.push({
		  			    path: "/Login",
		  			    name: "/Login",
		  				  query: {
		  				  }
		  			  });
		  },
		  upadvocate(){
			  var token = localStorage.getItem('token')||''
			  if(!token){
				   this.gologin()
			    // this.loginshow = true
			    return
			  }
			  var data={
			    
			  }
			  checktoken(data).then(res=>{
			    if(res.data.code==201){
			  	  console.log(res)
			  	  regettoken(data).then(res=>{
			  		  localStorage.setItem('token', res.data.data.token)
			  		  localStorage.setItem('refreshToken', res.data.data.refreshToken)
			  	  })
			    }
			    // if(res)
			  })
			data=this.ruleForm
			  if(!this.ruleForm.contact){
			    this.$alert('联系方式未填写', '联系方式未填写', {
			  	confirmButtonText: '确认',
			  	callback: action => {
			  		
			  	}
			    });
			    return
			  }
			if(!this.ruleForm.title){
			  this.$alert('主题未填写', '主题未填写', {
				confirmButtonText: '确认',
				callback: action => {
					
				}
			  });
			  return
			}
			if(!this.ruleForm.content){
			  this.$alert('内容未填写', '内容未填写', {
				confirmButtonText: '确认',
				callback: action => {
					
				}
			  });
			  return
			}
			upadvocate(data).then(res=>{
				if(res.data.code==200){
					this.$alert('留言成功', '留言成功', {
						confirmButtonText: '确认',
						callback: action => {
							this.richbox=''
							this.ruleForm={
							  title: '',
							  contact: '',
							  content: '',
							  type:this.ruleForm.type,
							}
						}
					});
									 
				}
			})  
		  },
		  phonelogin(){
		  			  var data=this.form
		  			  var that=this
		  			  if(this.form.mobile==''){
		  						this.$alert('请输入登录手机号', '请输入登录手机号', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								
		  							}
		  						});
		  				return;
		  			  }
		  			  if(this.form.mobile.length!=11){
		  						this.$alert('手机号长度位数错误', '手机号长度错误', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								
		  							}
		  						});
		  				return;
		  			  }
		  			  if( this.form.password==''){
		  						this.$alert('请填写密码', '存在未填项', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								
		  							}
		  						});
		  				return;
		  			  }
		  			  phonelogin(data).then(res=>{
		  				  if(res.data.data.flag==0){
		  				  					  this.$alert(res.data.data.msg, '账号不存在', {
		  				  					  	confirmButtonText: '确认',
		  				  					  	callback: action => {
		  				  					  		that.goregister()
		  				  					  	}
		  				  					  });
		  				  					  return
		  				  }
		  				  if(res.data.data.flag==2){
		  				  						  this.$alert(res.data.data.msg, '没有设置密码', {
		  				  							confirmButtonText: '确认',
		  				  							callback: action => {
		  				  								that.goreset()
		  				  							}
		  				  						  });
		  				  						  return
		  				  }
		  				  localStorage.setItem('token', res.data.data.token)
		  				  localStorage.setItem('refreshToken', res.data.data.refreshToken)
		  				  this.$router.go(0)
		  				  // this.$localStorage.set('token',res.data.data.token)
		  				  // this.$localStorage.set('refreshToken',res.data.data.refreshToken)
		  			  })
		  },
		  getsys(){
			getsys().then(res=>{
				this.richbox=res.data.registration_agreement
			})  
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showstep(ind) {
		       this.$refs.carousel.setActiveItem(ind)
		     },
		  goplate(id){
			  this.modules=id
			  this.page_index=1
			  this.getlist()
		  },
		  getexpert(){
			  var data={
			  	uuid:this.uuid
			  }  
			  getexpert(data).then(res=>{
					console.log(res.data)
					this.expertdata=res.data.data
					const loading = this.$loading({
			  			           lock: true,
			  			           text: 'Loading',
			  			           spinner: 'el-icon-loading',
			  			           background: 'rgba(0, 0, 0, 0.7)'
			  			         });
					loading.close();
			  			  // this.quicklist=res.data.data.list
			    }).catch(error => {
			  	  console.error(error);
			  });
		  },
		  getPlate(){
		  		var data={
		  			
		  		}  
		  		getPlate(data).then(res=>{
		  			this.platelist=res.data.data
		  		})
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
		  getRegion(){
			var data={}
			getRegion(data).then(res=>{
				this.regionlist=res.data.data
			})
		  },
			getMapcamp(){
				var data={
					type:this.camptype,
				}
				getMapcamp(data).then(res=>{
					console.log(res)
					
					this.maplist=res.data.data
					this.openmap=res.data.data[0]
					const loading = this.$loading({
							 lock: true,
							text: '页面载入……',
							// spinner: 'el-icon-loading',
							background: '#ffffff'
						   });
					loading.close();
				})
			},
			infoWindowClose (index) {
		        this.showinfowindow = false
			},
			infoWindowOpen (index) {
				this.openmap=this.maplist[index]
				this.showinfowindow = true
				console.log(this.maplist[index])
			},
			
			getpcset(){
				getPc().then(res=>{
					this.pcsetdata=res.data.data
					const loading = this.$loading({
							 lock: true,
							 text: 'Loading',
							 spinner: 'el-icon-loading',
							 background: 'rgba(0, 0, 0, 0.7)'
						   });
					loading.close();
					this.typetab(this.title)
				})  
			},
		  camptypetab(val){
			  this.region_type=val
			  this.page_index=1
			  this.getlist()
		  },
		  pagechange(val){
		  			  this.page_index=val
		  			   this.getlist()
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
			    			  this.types=res.data.data
							  this.category_id=res.data.data[0].id
							  this._getNewslist()
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		  /*
		   * 查看详情
		   * */
		  detail(e) {
		    this.$router.push({
		      path: "/travelerdetails",
		      name: "travelerdetails",
		      query: {
		        id: e
		      }
		    });
		  },
	  }
	};
</script>

<style scoped>
	body{
		background: #ffffff;
	}
	.weus_type{
		width: calc(170px - 40px) ;
		padding: 30px 20px;
		text-align: center;
		background-color: #f9f9f9;
		border-radius: 8px;
		font-size: 16px;
		min-height: 800px;
		line-height: 50px;
	}
	.weustype_item{
		padding: 0 20px;
		
	}
	.type_on{
		background-color: #1b9d57;
		color: #fff;
		border-radius: 6px;
	}
	.weus_main{
		width: 995px;
		
	}
	.weus_topimg{
		padding-bottom: 30px;
		
	}
	.weus_topimg img{
		width: 100%;
		border-radius: 10px;
		height: 248.75px;	
	}
	.weus_titles{
		line-height: 45px;
		    padding: 10px 0 15px 32px;
		    color:#909399;
	}
	.upfrom{
		padding: 10px 0 15px 32px;
	}
	.weus_title{
		    font-size: 31px;
		    color: #303133;
			text-align: left;
	}
	.weus_tips{
			font-size: 14px;
			text-align: left;
	}
	.weus_html{
		text-align: left;
	}
	
	#appbox{
		background: #ffffff;
	}
	.Home_column2{
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		margin: 0 auto;
		margin-top: 20px;
	}
	.expert_box{
		width:calc(100% - 40px);
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 20px;
		
	}
	.expert_img{
		width: 300px;
	
	}
	.expert_img img{
		width: 100%;
		object-fit: contain;
	}
	.expert_msgbox{
		flex: 1;
		margin-left: 20px;
		
	}
	.expert_title{
		padding: 20px;
		font-size: 20px;
		color:#1b9d57 !important;
		    font-weight: 600;
		    text-align: center;
	}
	.expert_msg{
		text-indent:4rem;
		font-size: 16px;
		color: #606266;
		    text-align: left;
	}
	.guidebox{
		padding: 30px 0px;
		border-top: 1px solid #EBEEF5;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items:center;
	}
	.guide_img{
		width: 480px;
		
	}
	.guide_img img{
		display: block;
		width: 100%;
		border-radius: 8px;
		object-fit: contain;
	}
	
	.guide_msgbox{
		width: calc(100% - 500px);
		
	}
	.guide_title{
		font-size: 28px;
		    color: #333;
		    line-height: 40px;
			    text-align: left;
	}
	.guide_subtitle{
		font-size: 18px;
		    color: #666;
		    line-height: 28px;
		    margin-top: 5px;
			    text-align: left;
	}
	.guide_msg{
		    margin: 30px 0px 50px;
		width: 490px;
		    font-size: 14px;
		    color: #666;
		    line-height: 30px;
			    text-align: left;
	}
	.guide_buttons{
		display: flex;
		justify-content: flex-start;
		
	}
	.column2_box{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: flex-end;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
		margin-bottom: 30px;
	}
	.expert_subtitle{
		text-indent:2rem;
		font-size: 14px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		    /* min-height: 48px; */
		
	}
	.mentor_imgs{
		width:100px !important;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		max-width: 210px;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
	  .intro_box{
		display: flex;
		justify-content: space-between;
		/* font-family: "楷体", "KaiTi", "SimKai", serif; */
		/* align-items: center; */
		
	  }
	  .intro_img{
		width: 280px;
		height: 280px;
		
	   }
	   .intro_title{
		font-size: 28px;
		color: rgb(32, 150, 150);
		margin-bottom: 15px;
	
	   }
	   .intro_subtitle{
		text-align: start;
		font-size: 20px;
		color: rgb(32, 150, 150);
		font-weight: bold;
		margin: 10px 0px;
	   }
	   
	  
	    .intro_paragraph{
		padding-left: 35px;
		text-align: start;
		font-size: 18px;
		letter-spacing: 1px;
		padding-top: 4px;
		padding-bottom: 4px;
		line-height: 25px;
		color: #333;
	   }
	   .intro_content{
		
		text-indent: 2em;
		text-align: start;
		font-size: 18px;
		letter-spacing: 1px;
		line-height: 25px;
		color: #333;
	   }
	   .intro_phonebox{
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	   }
	   .intro_phone{
		width: 33%;
		text-align: start;
		margin-top: 10px;
		font-size: 18px;
		letter-spacing: 1px;
	   }
</style>